import { Injectable } from '@angular/core';
import { SelectOptions } from '@cbuild/controls';
import { BaseUrlService, Urns } from '@cbuild/core';
import { CsHttpClientService } from '@cbuild/cs-common-data-services';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private propertySourceId: string;
  private baseUrl: string;

  public isCollapsed: boolean = true;

  constructor(
    private http: CsHttpClientService,
    private baseUrlService: BaseUrlService
  ) {
    this.propertySourceId = this.baseUrlService.getPropertySourceId();
    this.baseUrl = this.baseUrlService.getApiBaseURL();
  }

  private globalNavCollapsedSubject: BehaviorSubject<
    boolean
  > = new BehaviorSubject<boolean>(this.isCollapsed);
  $globalNavCollapsed = this.globalNavCollapsedSubject.asObservable();

  public navCollapsed(value: boolean): void {
    if (this.isCollapsed !== value) {
      this.isCollapsed = value;
      this.globalNavCollapsedSubject.next(value);
    }
  }

  public getForgeAccessToken(): Observable<{
    token: string;
  }> {
    return this.http.read<{ token: string }>(
      'api/account/forge/token',
      this.baseUrl
    );
  }

  public getPropertyUrns(blockId?: number): Observable<Array<Urns>> {
    return this.http.read<Array<Urns>>(
      `api/lite/assets/${this.propertySourceId}/urn?blockId=${blockId ?? ''}`,
      this.baseUrl
    );
  }

  public getCommercialBlocks(): Observable<SelectOptions> {
    return this.http.read<SelectOptions>(
      `api/lite/property-commercial-block/${this.propertySourceId}`,
      this.baseUrl
    );
  }

  public getCommercialFloors(blockId: number): Observable<SelectOptions> {
    return this.http.read<SelectOptions>(
      `api/lite/commercial-floors/${blockId}`,
      this.baseUrl
    );
  }
}
